export const pageCharts = {
  //release
  person: [
    "viz-populationAgeSexPerson",
    "viz-race",
    "viz-birthyearnote",
    "viz-ethnicity",
  ],
  observationPeriod: [
    "viz-ageatfirstobservation",
    "viz-agebysex",
    "viz-cumulativeobservation",
    "viz-observationbymonth",
    "viz-observationbyage",
    "viz-observationbysex",
  ],
  death: [
    "viz-ageatdeath",
    "viz-deathbytype",
    "viz-recordproportionbyagesexyear",
    "viz-deathrecordproportionbymonth",
  ],
  domainTable: ["viz-recordproportionbymonth"],
  dataDensity: ["viz-densityOverview", "viz-recordsperperson"],
  cohortReport: ["viz-beforeIndex", "viz-afterIndex", "viz-between"],
  // concept: ["viz-recordproportionbymonth"],
  //Source
  dataQualityHistory: [
    "viz-dataqualityresults",
    "viz-sourcedataqualityresultsbycategory",
    "viz-sourcedataqualityresultsbydomain",
  ],
  dataSourceOverview: ["issues_releases", "population_releases"],
  sourceConceptOverlay: ["viz-sourcerecordproportionbymonth"],
  costTable: ["viz-costtime"],
};
